import throttle from './lib/throttle';

// Menu Scroll Behavior
document.addEventListener('DOMContentLoaded', function () {
  const mainMenu = document.getElementById('main-menu-frontpage');
  if (!mainMenu) return;

  function handleScroll() {
    if (window.matchMedia('(min-width: 768px)').matches) return; // Only apply on mobile

    if (window.scrollY > 120) {
      mainMenu.classList.add('bg-background-quaternary');
      mainMenu.classList.remove('bg-transparent');
    } else {
      mainMenu.classList.remove('bg-background-quaternary');
      mainMenu.classList.add('bg-transparent');
    }
  }

  window.addEventListener('scroll', throttle(handleScroll, 200));
  handleScroll(); // Call once on load
});
